import { Steps } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { customers } from "../../../actions/customers";
import {
  get_currencies,
  headerTitles,
} from "../../../actions/masterdata/masterdata";
import { get_person_accounts, get_purposes } from "../../../actions/z_accounts";
import close from "../../../assets/icons/close.png";
import AdditionalInfo from "./AdditionalInfo";
import Recipients from "./Recipients";
import Review from "./Review";
import SchedulePaymentForm from "./SendPay";
import TransferInfo from "./TransferInfo";
const { Step } = Steps;

const SendMoney = ({ setOpenAddNew, cb }) => {
  const dispatch = useDispatch();
  const [dbAcc, setDBAcc] = useState({});
  const [crAcc, setCrAcc] = useState({});
  const [mainData, setMainData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const steps = [
    {
      title: "Beneficiaries",
      content: (
        <Recipients
          next={next}
          setDBAcc={setCrAcc}
          acc={crAcc}
          mainData={mainData}
          onSubmit={(data) => {
            setMainData((b) => ({
              ...b,
              ...data,
            }));
          }}
        />
      ),
    },
    {
      title: "Amount & source",
      content: (
        <SchedulePaymentForm
          next={next}
          back={prev}
          setDBAcc={setDBAcc}
          acc={dbAcc}
          crAcc={crAcc}
          mainData={mainData}
          onSubmit={(data) => {
            setMainData((b) => ({
              ...b,
              ...data,
            }));
          }}
        />
      ),
    },
    {
      title: "Additional info",
      content: (
        <AdditionalInfo
          next={next}
          back={prev}
          dbAcc={dbAcc}
          crAcc={crAcc}
          mainData={mainData}
          setMainData={setMainData}
        />
      ),
    },
    {
      title: "Review",
      content: (
        <Review
          dbAcc={dbAcc}
          crAcc={crAcc}
          mainData={mainData}
          setMainData={setMainData}
          toStart={() => {
            setCurrentStep(0);
            setCrAcc({});
            setDBAcc({});
            setMainData({});
            cb?.();
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch(
      headerTitles({
        title: "Transfer Money",
        description: "Payments Transfer to Recipients Accounts",
      })
    );
    dispatch(
      get_person_accounts({
        page_number: 1,
        page_size: 50,
        person_id: "ID-1146",
      })
    );
    dispatch(
      customers({
        type: "individual",
      })
    );
    dispatch(get_currencies());
    dispatch(get_purposes());
  }, []);

  return (
    <>
      <div className="upload_payment_parent send-payment">
        <div className="flex-between sec-head">
          <div className="tabsSection">
            <span className="active">Transfer Money</span>
          </div>
          <img
            src={close}
            width={20}
            onClick={() => {
              setOpenAddNew(false);
              cb?.();
            }}
          />
        </div>
        <div className="hr" />
        <div className="p2">
          {mainData?.paid ? (
            <Review
              paid={true}
              dbAcc={dbAcc}
              crAcc={crAcc}
              mainData={mainData}
              setMainData={setMainData}
              toStart={() => {
                setCurrentStep(0);
                setCrAcc({});
                setDBAcc({});
                setMainData({});
              }}
            />
          ) : (
            <>
              <Steps current={currentStep}>
                {steps.map((item, index) => (
                  <Step key={index} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content" style={{ marginTop: 20 }}>
                {steps[currentStep].content}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="upload_payment_parent send-payment mt2">
        <TransferInfo />
      </div>
    </>
  );
};

export default SendMoney;
